var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link': 'button',{tag:"component",class:[_vm.cssClass || `u-button u-button__type-${_vm.theme} u-button__size-${_vm.size}`],attrs:{"to":_vm.to,"disabled":_vm.disabled}},[_c('span',{staticClass:"u-button__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }